import { createSelector } from 'reselect';

import {
  FETCH_TRANSITIONS_DAT_SUCCESS, FETCH_TRANSITIONS_JSON_SUCCESS,
} from '../../actions/transitions';

import { extractTransitions, invertObject } from '../../utils/common';

import getCurrentStepsStatistics from '../../utils/statistics';
import getUserStepsStatistics from '../../utils/userStepsStatistics';

const initialState = {
  transitionsDat: [],
  transitionsJson: {
    // states: {},
    // dates: {},
    // steps: {},
    // users: {},
    // projects: {}
  },
};

export default function transitionsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TRANSITIONS_DAT_SUCCESS:
      return {
        ...state,
        transitionsDat: extractTransitions(action.payload.data),
    };
    case FETCH_TRANSITIONS_JSON_SUCCESS:
      return {
        ...state,
        transitionsJson: action.payload.data,
      };
    default:
      return state;
  }
}

const getTransitionsDat = state => state.transitions.transitionsDat;
const getTransitionsJson = state => state.transitions.transitionsJson;
const getTransitionsDates = state => state.transitions.transitionsJson.dates;

export const currentStepsStatisticsSelector = projects => createSelector(
  [getTransitionsDat, getTransitionsJson],
  (transitionsDat, transitionsJson) =>
    getCurrentStepsStatistics(projects, transitionsDat, transitionsJson)
);

export const userTransitionsSelector = createSelector(
  [getTransitionsDat, getTransitionsJson],
    (transitionsDat, transitionsJson) => 
    getUserStepsStatistics(transitionsDat, transitionsJson)
);

export const transitionsJsonDatesSelector = createSelector(
  [getTransitionsDates],
  dates => dates
);

export const invertedTransitionsJsonSelector = createSelector(
  [getTransitionsJson],
    (transitionsJson) => {
      const toBeInverted = ['states', 'projects', 'users'];
      const invertedTransitionsJson = {};
      toBeInverted.forEach(objPart => {
        invertedTransitionsJson[objPart] = invertObject(transitionsJson[objPart]);
      });
      return invertedTransitionsJson;
    }
);
